export default __webpack_public_path__ + "static/media/progress.ab51a34d.png";